import React, { Component } from 'react';

class Navegacao extends Component {
    getDesabilitarAnterior() {
        return this.props.questaoAtual === 1;
    }
    getDesabilitarProxima() {
        return this.props.questaoAtual === this.props.totalQuestoes;
    }
    render() {
        return (<div className={" adap-white edb-round-large edb-padding-small " + this.props.className}>
            <div className="edb-cell-row">

                <div className=" edb-cell edb-cell-middle">
                    <button className="edb-button edb-xlarge edb-padding-small-mobile" onClick={this.props.onClickAnterior} disabled={this.getDesabilitarAnterior()}>
                        <i className="fas fa-arrow-left"></i>
                    </button>

                    <button className="edb-button edb-xlarge edb-padding-small-mobile" onClick={this.props.onClickProxima} disabled={this.getDesabilitarProxima()}>
                        <i className="fas fa-arrow-right"></i>
                    </button>

                    <span className="edb-text-bold edb-margin-small-left edb-margin-small-right edb-padding-small-top edb-hide-small">Questão</span>
                    <span className="edb-text-bold edb-margin-small-right edb-padding-small-top edb-small edb-hide-large edb-hide-medium">Questão</span>

                    <span className="edb-text-bold">{this.props.questaoAtual}</span>
                    <span className="edb-padding-small">/</span>
                    <span>{this.props.totalQuestoes}</span>

                </div>

                <div className=" edb-cell edb-cell-middle edb-right-align">
                    {!this.props.esconderBtnDuvida && <button className="edb-button edb-padding-small-mobile" onClick={this.props.onClickProximaDuvida} disabled={!this.props.temQuestaoDuvida}>
                        <i className="edb-large fas fa-question-circle"></i>
                        <i className="edb-large fas fa-chevron-right"></i>
                        <div className="edb-tiny edb-line-height-tiny edb-hide-medium  edb-hide-small">PRÓXIMA <br /> DÚVIDA</div>
                    </button>}
                    {!this.props.esconderBtnBranco && <button className="edb-button edb-padding-small-mobile" onClick={this.props.onClickProximaEmBranco} disabled={!this.props.temQuestaoEmBranco}>
                        <i className="edb-large far fa-circle"></i>
                        <i className="edb-large fas fa-chevron-right"></i>
                        <div className="edb-tiny edb-line-height-tiny edb-hide-medium edb-hide-small">PRÓXIMA <br /> EM BRANCO</div>
                    </button>}
                    
                    {/*********** Resposta Correta/Incorreta **************/}
                    {this.props.resposta === true &&  <div className="edb-padding-right">
                        <i className="fas fa-check edb-large adap-text-green"></i>
                        &nbsp;
                        <span className="edb-large edb-text-bold adap-text-green">Resposta correta</span>
                    </div>}

                    {this.props.resposta === false && <div className="edb-padding-right">
                        <i className="fas fa-times edb-large adap-text-red"></i>
                        &nbsp;
                        <span className="edb-large edb-text-bold adap-text-red">Resposta incorreta</span>
                    </div>}
                </div>
            </div>
        </div>);
    }
}

export default Navegacao;